import { Col, Divider, Form, Row } from 'antd';
import { openErrorNoti } from 'presentation/components/Notification';
import { FormInput } from 'presentation/components/form/FormInput.component';
import { FormRadio } from 'presentation/components/form/FormRadio.component';
import { FormSelect } from 'presentation/components/form/FormSelect.component';
import { FormTextArea } from 'presentation/components/form/FormTextArea.component';
import { completeFetching, startFetching } from 'presentation/redux/features/app/appSlice';
import { useAppDispatch } from 'presentation/redux/hooks';
import { useEffect, useState } from 'react';
import { MASTER_CATEGORY_LIST } from 'utilities/constants/COMMON';
import { commonHelpers } from 'utilities/helpers';
import { StepProps } from '../props/StepProps';
import { ButtonList } from './ButtonList';

const YES_NO_OPTIONS = [
    {
        label: 'あり',
        value: 1,
    },
    {
        label: 'なし',
        value: 0,
    },
];

const YES_NO_OPTIONS_DEPEND = [
    {
        label: 'あり',
        value: '10',
    },
    {
        label: 'なし',
        value: '20',
    },
];

export const PurchaseStepTwo = ({
    data,
    masterData,
    setOfferId,
    next,
    setIsChange,
    ...props
}: StepProps) => {
    const [btnDisable, setBtnDisable] = useState<boolean>(true);
    const [requiredOther1, setRequiredOther1] = useState<boolean>(false);
    const [requiredOther2, setRequiredOther2] = useState<boolean>(false);
    const [requiredRelation, setRequiredRelation] = useState<boolean>(false);
    const [requiredDependent, setRequiredDependent] = useState<boolean>(false);
    const [disableLoanBalance, setDisableLoanBalance] = useState(true);
    const [form] = Form.useForm();
    const dispatch = useAppDispatch();

    useEffect(() => {
        props.scrollTop && props.scrollTop();
    }, []);

    useEffect(() => {
        if (data) {
            if (data.homePossessionType == '10') setDisableLoanBalance(false);
            form.setFieldsValue(data);
            setRequiredOther2(data?.existFlagPropertyOther == '1');
            setRequiredOther1(data?.existFlagProperty == 1);
            setRequiredRelation(data?.existFlagRelation == 1);
            setRequiredDependent(data?.existFlagRelation == 1 && data?.dependentType == '10');
            onChangeForm();
            form.getFieldValue('DependentType') ?? form.setFieldsValue({ dependentType: '20' });
        }
    }, [data]);

    const onChangeForm = () => {
        form.validateFields({
            validateOnly: true,
        })
            .then(() => {
                setBtnDisable(false);
            })
            .catch((err) => {
                setBtnDisable(err.errorFields.length > 0);
            });
    };

    const changeBtnDisable = (isError: any) => {
        if (isError) {
            setBtnDisable(true);
        } else {
            onChangeForm();
        }
    };

    const submitNext = async () => {
        try {
            dispatch(startFetching());
            const payload = {
                ...form.getFieldsValue(),
                dependentType: requiredRelation ? form.getFieldValue('dependentType') : '20',
                count01: form.getFieldValue('count01') ?? 0,
                livingTogetherCount: form.getFieldValue('livingTogetherCount') ?? 0,
                dependentCountChild: form.getFieldValue('dependentCountChild') ?? 0,
                dependentCountParent: form.getFieldValue('dependentCountParent') ?? 0,
                housingLoanBalance: commonHelpers.toNumberOnly(
                    form.getFieldValue('housingLoanBalance'),
                ),
                exist_flag: data?.existFlagRelation,
                quantity01: requiredOther1
                    ? commonHelpers.toNumberOnly(form.getFieldValue('quantity01'))
                    : 0,
                quantity02: requiredOther1
                    ? commonHelpers.toNumberOnly(form.getFieldValue('quantity02'))
                    : 0,
                others01: requiredOther1 ? form.getFieldValue('others01') : '',
                others02: requiredOther2 ? form.getFieldValue('others02') : '',
                loanAmountHouse: commonHelpers.toNumberOnly(form.getFieldValue('loanAmountHouse')),
                loanAmountCar: commonHelpers.toNumberOnly(form.getFieldValue('loanAmountCar')),
                loanAmountInvest: commonHelpers.toNumberOnly(
                    form.getFieldValue('loanAmountInvest'),
                ),
                loanAmountOther: commonHelpers.toNumberOnly(form.getFieldValue('loanAmountOther')),
                procedureId: data?.procedureId,
                purchaseOfferId: data?.purchaseOfferId,
            };
            const response = await props.purchaseUseCase.savePurchaseIndividualStep2(payload);
            if (response) {
                setOfferId && setOfferId(response.result?.purchaseOfferId ?? '');
                next && next();
            }
        } catch (error: any) {
            openErrorNoti();
        } finally {
            dispatch(completeFetching());
        }
    };

    useEffect(() => {
        props.scrollTop && props.scrollTop();
    }, []);

    return (
        <>
            <Form
                form={form}
                initialValues={{
                    dependentType: '20',
                }}
                onValuesChange={() => {
                    onChangeForm();
                    setIsChange && setIsChange(true);
                }}
                onFinish={submitNext}
            >
                <Row className="min-w-min">
                    <div className="w-full mb-[48px]">
                        <span className="content-step-form heading-step-form">家族</span>
                        <Divider className="mb-6 my-1" />
                        <Row gutter={[0, 12]} className="mb-6">
                            <Col span={12} className="pr-[12px]">
                                <FormRadio
                                    label="配偶者"
                                    name="existFlagRelation"
                                    options={YES_NO_OPTIONS}
                                    required
                                    labelClassName="content-step-form label-step-form"
                                    onChange={(e) => {
                                        setRequiredRelation(e == '1');
                                    }}
                                />
                            </Col>
                            <Col span={12} className="pl-[12px]">
                                <FormRadio
                                    label="配偶者の扶養義務"
                                    name="dependentType"
                                    options={YES_NO_OPTIONS_DEPEND}
                                    required
                                    labelClassName="content-step-form label-step-form"
                                    onChange={(e) => {
                                        setRequiredDependent(e == '10');
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row gutter={[0, 12]}>
                            <Col span={12} className="pr-[12px]">
                                <FormInput
                                    label="子供"
                                    name="count01"
                                    type="number"
                                    maxLength={2}
                                    max={99}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                    suffix="人"
                                    required={true}
                                />
                            </Col>
                            <Col span={12} className="pl-[12px]">
                                <FormInput
                                    label="扶養の子供"
                                    name="dependentCountChild"
                                    type="number"
                                    required={true}
                                    maxLength={2}
                                    max={99}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                    suffix="人"
                                />
                            </Col>
                        </Row>
                        <Row gutter={[0, 12]}>
                            <Col span={12} className="pr-[12px]">
                                <FormInput
                                    label="同居している子供"
                                    name="livingTogetherCount"
                                    type="number"
                                    required={true}
                                    maxLength={2}
                                    min={0}
                                    max={99}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                    suffix="人"
                                />
                            </Col>
                            <Col span={12} className="pl-[12px]">
                                <FormInput
                                    label="扶養している父母"
                                    name="dependentCountParent"
                                    type="number"
                                    required={true}
                                    maxLength={2}
                                    min={0}
                                    max={99}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                    suffix="人"
                                />
                            </Col>
                        </Row>
                    </div>

                    <div className="w-full mb-[48px]">
                        <span className="content-step-form heading-step-form">その他</span>
                        <Divider className="mb-6 my-1" />
                        <Row gutter={[0, 12]}>
                            <Col span={12} className="pr-[12px]">
                                <FormSelect
                                    options={
                                        masterData?.[
                                            MASTER_CATEGORY_LIST.HOME_BUILDING_TYPE_CLASSIFICATION
                                        ]
                                    }
                                    label="自宅の建物区分"
                                    required
                                    name="homeBuildingType"
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                />
                            </Col>
                            <Col span={12} className="pr-[12px]">
                                <FormSelect
                                    options={
                                        masterData?.[
                                            MASTER_CATEGORY_LIST.HOME_POSSESSION_TYPE_CLASSIFICATION
                                        ]
                                    }
                                    label="自宅の所有区分"
                                    name="homePossessionType"
                                    required
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                    onChange={(value) => {
                                        setDisableLoanBalance(value === '20' || value === '30');
                                        if (value === '10') {
                                            form.setFieldsValue({ housingLoanBalance: undefined });
                                        } else if (value === '20' || value === '30') {
                                            form.setFieldsValue({ housingLoanBalance: 0 });
                                        }
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row gutter={[0, 12]}>
                            <Col span={12} className="pr-[12px]">
                                <FormInput
                                    label="住宅ローン残債"
                                    name="housingLoanBalance"
                                    type="number"
                                    required={!disableLoanBalance}
                                    maxLength={9}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                    suffix="万円"
                                    disabled={disableLoanBalance}
                                />
                            </Col>
                        </Row>
                        <Row gutter={[0, 12]}>
                            <Col span={12} className="pr-[12px]">
                                <FormRadio
                                    options={YES_NO_OPTIONS}
                                    required
                                    label="投資用不動産"
                                    name="existFlagProperty"
                                    labelClassName="content-step-form label-step-form"
                                    onChange={(e) => {
                                        setRequiredOther1(e == '1');
                                    }}
                                />
                            </Col>
                        </Row>
                        <Row gutter={[0, 12]}>
                            <Col span={12} className="pr-[12px]">
                                <FormInput
                                    label="区分マンション（戸数）"
                                    name="quantity01"
                                    required={requiredOther1}
                                    disabled={!requiredOther1}
                                    type="number"
                                    maxLength={5}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                    suffix="戸"
                                />
                            </Col>
                            <Col span={12} className="pr-[12px]">
                                <FormInput
                                    label="一棟アパート・戸建て（棟数）"
                                    name="quantity02"
                                    required={requiredOther1}
                                    disabled={!requiredOther1}
                                    type="number"
                                    maxLength={5}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                    suffix="棟"
                                />
                            </Col>
                        </Row>
                        <Row gutter={[0, 12]}>
                            <Col span={24} className="pr-[12px]">
                                <FormTextArea
                                    label="投資用不動産詳細（任意）"
                                    name="others01"
                                    disabled={!requiredOther1}
                                    maxLength={1000}
                                    rows={5}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                />
                            </Col>
                        </Row>

                        <Row gutter={[0, 12]}>
                            <Col span={12} className="pr-[12px]">
                                <FormRadio
                                    options={YES_NO_OPTIONS}
                                    label="その他所有不動産"
                                    required
                                    name="existFlagPropertyOther"
                                    labelClassName="content-step-form label-step-form"
                                    onChange={(e) => {
                                        setRequiredOther2(e == '1');
                                    }}
                                />
                            </Col>
                        </Row>

                        <Row gutter={[0, 12]}>
                            <Col span={24} className="pr-[12px]">
                                <FormTextArea
                                    label="その他所有不動産詳細"
                                    name="others02"
                                    required={requiredOther2}
                                    disabled={!requiredOther2}
                                    currentForm={form}
                                    onValidateError={changeBtnDisable}
                                    maxLength={1000}
                                    rows={5}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                />
                            </Col>
                        </Row>
                    </div>

                    <div className="w-full mb-[48px]">
                        <span className="content-step-form heading-step-form">借入</span>
                        <Divider className="mb-6 my-1" />
                        <Row gutter={[0, 12]}>
                            <Col span={12} className="pr-[12px]">
                                <FormInput
                                    label="借入額（自宅）"
                                    name="loanAmountHouse"
                                    required
                                    type="number"
                                    maxLength={7}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                    suffix="万円"
                                />
                            </Col>
                            <Col span={12} className="pl-[12px]">
                                <FormInput
                                    label="借入額（自動車）"
                                    name="loanAmountCar"
                                    required
                                    type="number"
                                    maxLength={7}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                    suffix="万円"
                                />
                            </Col>
                        </Row>
                        <Row gutter={[0, 12]}>
                            <Col span={12} className="pr-[12px]">
                                <FormInput
                                    label="借入額（投資用不動産）"
                                    name="loanAmountInvest"
                                    required
                                    type="number"
                                    maxLength={7}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                    suffix="万円"
                                />
                            </Col>
                            <Col span={12} className="pl-[12px]">
                                <FormInput
                                    label="借入額（その他）"
                                    name="loanAmountOther"
                                    type="number"
                                    required
                                    maxLength={7}
                                    size={'large'}
                                    labelClassName="content-step-form label-step-form"
                                    suffix="万円"
                                />
                            </Col>
                        </Row>
                    </div>
                    <ButtonList {...props} next={submitNext} disable={btnDisable} />
                </Row>
            </Form>
        </>
    );
};
